import Standards from "@/components/site/Standards";

export default function StandardsPage() {
  return <Standards />;
}
